import { inject, Injectable, OnDestroy } from '@angular/core';
import { Observable, ReplaySubject, Subscription } from 'rxjs';
import { MicrosoftDialPlanFieldConfig } from '../models/generated/ziroModels';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { MicrosoftTenantsResource } from '../../admin/contexts/microsoft-tenants.resource';

/**
 * This class is only needed for the global user permissions page. Once that's migrated to the new RBAC system,
 * we can delete this context. Use {@link MicrosoftDialPlansFieldConfigContext} instead.
 */
@Injectable({ providedIn: 'root' })
export class MicrosoftLegacyGlobalDialPlansFieldConfigContext implements OnDestroy {
  private _http = inject(HttpClient);
  private _microsoftTenantsResource = inject(MicrosoftTenantsResource);

  _stateSource = new ReplaySubject<MicrosoftDialPlanFieldConfig[]>(1);
  state$ = this._stateSource.asObservable();

  private _subscriptions = new Subscription();

  constructor() {
    const sub = this._microsoftTenantsResource.__getAll().subscribe((tenants) => {
      if (!tenants.length || !tenants[0].applicationGuid) {
        this._stateSource.next([]);
        return;
      }
      this.init().subscribe();
    });

    this._subscriptions.add(sub);
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  init(): Observable<void> {
    return this._getGlobalDialPlansFieldConfigs().pipe(
      map((dialPlans) => {
        this._stateSource.next(dialPlans);
      }),
    );
  }

  private _getGlobalDialPlansFieldConfigs(): Observable<MicrosoftDialPlanFieldConfig[]> {
    return this._http.get<MicrosoftDialPlanFieldConfig[]>(`/services/microsoft/field-configs/dial-plans`);
  }
}
